import React from 'react';
import PropTypes from 'prop-types';

export default function HTML({ rawMarkup, className }) {
  /* eslint-disable react/no-danger */
  return (
    <div className={className}>
      <span dangerouslySetInnerHTML={{ __html: rawMarkup }} />
    </div>
  );
  /* eslint-enable react/no-danger */
}

HTML.propTypes = {
  className: PropTypes.string.isRequired,
  rawMarkup: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/formElements/HTML.js